/* eslint-disable no-sparse-arrays */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/**
 * @deprecated
 */
import React, {
  useState,
  forwardRef,
  useRef,
  useImperativeHandle,
  useEffect,
  useCallback,
  useMemo,
} from 'react';
import {
  StyleSheet,
  View,
  VirtualizedList,
  TouchableOpacity,
  ActivityIndicator,
  // eslint-disable-next-line no-unused-vars
  RefreshControl,
  Dimensions,
  Animated,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import debounce from 'lodash.debounce';
import { useHeaderHeight } from '@react-navigation/elements';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { LegendList } from '@legendapp/list';
import { showPopup } from '@/store/modal';
import {
  paginationAdded,
  paramsReseted,
  filterAdded,
  selectParams,
} from '@/store/params';

import SociollaText from '@components/sociolla/SociollaText';
import { NoTranslate } from '@components/shared/TranslationContext';
import SociollaFilter from '@components/sociolla/SociollaFilter';
import SearchTable from '@components/table/SearchTable';
import Pagination from '@components/table/Pagination';
import Image from '@components/global/Image';
import Button from '@components/form/Button';
import CheckBox from '@components/form/CheckBox';
import ModalFull from '@components/modal/ModalFull';
import SearchInputMobile from '@components/global/SearchInputMobile';
import StatusBadge from '@components/global/StatusBadge';
import VipBadge from '@components/customer/VipBadge';
import { setSavedFilter } from '@global/helpers';
import Colors from '@global/colors';
import { isWeb, isMobileWeb, isAndroid, isNative } from '@global/screens';
import { buttonPrimary, buttonRounded } from '@/assets/styles/buttonStyles';

const defaultLimit = isWeb ? 10 : 15;
const dimensions = Dimensions.get('screen');
const screenHeight = dimensions.height;
const img = require('@/assets/img/default/user-image.png');
//const screenWidth = dimension.width;

const Wrapper = ({ children, styleContainer, scrollItem }) => {
  if (!isWeb && !isMobileWeb) {
    return <View>{children}</View>;
  } else {
    return (
      <View
        style={[
          styles.container,
          scrollItem ? { flex: 1 } : {},
          styleContainer,
        ]}>
        {children}
      </View>
    );
  }
};

function SociollaTable(props, ref) {
  const {
    testID = 'sociolla-table',
    name = true,
    table,
    datas,
    emptyLabel,
    headerComponent,
    itemComponent,
    style,
    searchPlaceholder,
    showFilter,
    showSearch,
    searchBorder,
    hideSearch,
    showPagination,
    customAction,
    scrollItem,
    count,
    loading,
    loadingLoadMore,
    localParams,
    hideBottomPagination,
    searchKey,
    onLoadMore,
    onSearchTable,
    callBackAction,
    callBackRowPress,
    maxHeight,
    withHeader = true,
    styleContainer = {},
    topComponent = true,
    minusHeight = 0,
    plusHeight = 0,
    threshold = 0,
    totalData = 0,
    styleRow = {},
    slot = false,
    keyExtractor = false,
    filterName = null,
    ...otherProps
  } = props;

  const flatlistRef = useRef();
  const dimension = Dimensions.get('window');
  const [showSkeleton, setShowSkeleton] = useState(false);

  const navigation = useNavigation();

  const dispatch = useDispatch();
  const isShowFilter = useSelector((state) => state.modal.sociollaFilter);
  const paramsState = useSelector(selectParams(filterName)); // existing parameters for filter

  const [options, setOptions] = useState(false);
  const [columnData, setColumnData] = useState(null);
  const [columnIndex, setColumnIndex] = useState(null);

  const [newTable, setNewTable] = useState([]);
  const [originalTable, setOriginalTable] = useState([]);
  const [filterTable, setFilterTable] = useState([]);
  const tableAdded = useMemo(
    () => newTable.length > originalTable.length,
    [newTable, originalTable],
  );
  const isFiltered = useMemo(() => {
    if (props.isFiltered != undefined) {
      return props.isFiltered;
    }
    let filter = {};
    if (localParams) {
      filter = localParams.filter;
    } else {
      filter = paramsState.filter;
    }
    let result = Boolean(filter && Object.keys(filter).length);
    const or = result['$or'] || [];
    const isArr = Array.isArray(searchKey);
    if (isArr && searchKey.length > 0 && or.length === searchKey.length) {
      result = false;
    }
    if (!isArr && searchKey && result[searchKey]) {
      result = false;
    }
    return result;
  }, [localParams, paramsState, searchKey]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [originalLength, setOriginalLength] = useState(0);
  const showLoadMoreLoading = useMemo(() => {
    let load = true;
    let { skip } = { ...paramsState };
    if (localParams) {
      skip = localParams.skip;
    }
    // const endLoad = datas.length % defaultLimit > 0;
    const endLoad = skip > datas.length;
    const lengthLoad = datas.length > originalLength;
    const isEnd = totalData > 0 ? datas.length >= totalData : false;
    if (
      (!loadingLoadMore && !loading && endLoad && scrollItem && lengthLoad) ||
      isEnd
    ) {
      load = false;
    }
    return load;
  }, [loadingLoadMore, datas, scrollItem, loading, originalLength]);

  const getItemCount = (data) => data.length;
  const getItem = (data, index) => data[index];

  const triggerAction = (action, data, index, column) => {
    callBackAction({
      name: action.name,
      data,
      index,
    });
  };

  const headerAction = (column, index) => {
    if (column.type == 'options') {
      setOptions(!options);
      setColumnData(column);
      setColumnIndex(index);
    }
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  let heightHeader = 0;
  try {
    if (navigation) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      heightHeader = useHeaderHeight();
    }
  } catch (error) {}
  const insets = useSafeAreaInsets();
  const height =
    screenHeight -
    (isAndroid ? insets.top + insets.bottom : 0) -
    (showSearch ? 65 : 0) -
    heightHeader -
    minusHeight +
    plusHeight;
  const safeLegendListHeight = useMemo(() => {
    if (Number.isFinite(height) && height > 0) {
      return height;
    }
    return Math.max(Math.round(screenHeight * 0.5), 240);
  }, [height]);
  // const height =
  //   screenHeight -
  //   (isWeb ? 155 : heightHeader) -
  //   (showSearch && !isWeb ? 180 : 0);

  // eslint-disable-next-line no-unused-vars
  const percenToNumber = (data) => {
    return Number(data.replace('%', ''));
  };

  const addHeader = (data, indexOptions, indexHeader, indexAdded = 1) => {
    try {
      let newDataHeader = [...newTable];
      // set checked
      newDataHeader[indexHeader].options[indexOptions].checked = !data.checked;

      const checkedLen = newDataHeader[indexHeader].options.filter(
        (x) => x.checked,
      ).length;
      if (!data.checked) {
        // remove header
        setColumnIndex(columnIndex - 1);
        if (!checkedLen) {
          newDataHeader = originalTable;
        } else {
          const getIndex = newDataHeader.findIndex((x) => x.data === data.data);
          newDataHeader.splice(getIndex, 1);
          // newDataHeader = newDataHeader.map((dt, index) => {
          //     if (index !== indexHeader && dt.type !== 'options') {
          //         let newWidth = Math.floor(percenToNumber(dt.width) + data.minus)
          //         return {
          //             ...dt,
          //             width: newWidth.toString() + '%'
          //         }
          //     } else return dt
          // })
        }
      } else {
        // add header
        setColumnIndex(columnIndex + 1);
        indexAdded += checkedLen;
        // let minusWidth = percenToNumber(data.width) / (newDataHeader.length - 1)
        // newDataHeader = newDataHeader.map((dt, index) => {
        //     if (index !== indexHeader && dt.type !== 'options') {
        //         let newWidth = Math.floor(percenToNumber(dt.width) - minusWidth)
        //         return {
        //             ...dt,
        //             width: newWidth.toString() + '%'
        //         }
        //     } else return dt
        // })
        // newDataHeader[indexHeader].options[indexOptions]['minus'] = minusWidth
        newDataHeader.splice(indexAdded, 0, data);
      }

      setNewTable(newDataHeader);
    } catch (e) {
      console.log(e);
    }
  };

  const generateWidth = (column) => {
    let width = column.width;
    if (tableAdded && column.type !== 'options') {
      width = Math.floor(97 / (newTable.length - 1)) + '%';
    }
    return width;
  };

  const renderHeaderDekstop = () => (
    <NoTranslate>
      <View testID={`${testID}-header`} style={styles.tableHeader}>
        {newTable.map((column, index) => {
          {
            return (
              <View
                key={index}
                style={[
                  styles.columntable,
                  { width: generateWidth(column) },
                  index + 1 < newTable.length
                    ? {
                        borderRightColor: Colors.white,
                        borderRightWidth: 2,
                        height: 48,
                      }
                    : {},
                  { position: 'relative' },
                ]}>
                <TouchableOpacity onPress={() => headerAction(column, index)}>
                  {column.type == 'options' ? (
                    <Image
                      style={{ width: 5, height: 20 }}
                      width={5}
                      height={20}
                      svg={true}
                      source={require('@assets/img/icons/more-vertical-white.svg')}
                    />
                  ) : (
                    <SociollaText style={styles.columntableTxt}>
                      {column.label}
                    </SociollaText>
                  )}
                </TouchableOpacity>
                {/* {
                                    options && column.options && column.options.length && (
                                        <View
                                            style={{
                                                width:275,
                                                position:'absolute',
                                                right:0,
                                                top:42,
                                                backgroundColor:Colors.white,
                                                zIndex:2,
                                                elevation: 5,
                                                flex:1
                                            }}
                                        >
                                            {
                                                column.options.map((item, idx) => (
                                                    <TouchableOpacity
                                                        style={{paddingVertical:12,paddingHorizontal:15,borderBottomColor:Colors.grey0,borderBottomWidth:1}}
                                                        key={`more-field-${idx}`}
                                                    >
                                                        <CheckBox
                                                            value={item.checked}
                                                            checked={item.checked}
                                                            checkboxStyle={{width:16,height:16}}
                                                            onChange={() => addHeader(item, idx, index, column.index)}
                                                        >
                                                            <SociollaText style={{lineHeight:18}}>{item.label}</SociollaText>
                                                        </CheckBox>
                                                    </TouchableOpacity>
                                                ))
                                            }
                                        </View>
                                    )
                                } */}
              </View>
            );
          }
        })}
      </View>
    </NoTranslate>
  );

  const Item = ({ column, data, index, style, item }) => {
    return (
      <>
        {column?.label === 'Description' && (
          <View
            key={'text' + index}
            style={[styles.columnRowTxt, style, column.styleItem || {}]}>
            <SociollaText
              style={[
                item[column.data + 'Style'] || {},
                { fontSize: 11 },
                item[column.data + 'Style']
                  ? {
                      width: 125,
                      textAlign: 'center',
                      maxHeight: 27,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 'bold',
                    }
                  : {},
              ]}
              numberOfLines={column.numberOfLines || 0}>
              {item?.is_default && (
                <View style={styles.badgeContainer}>
                  <SociollaText style={styles.badgeText}>Default</SociollaText>
                </View>
              )}
              {data}
            </SociollaText>
          </View>
        )}
        {column?.label === 'Customer Name' && (
          <View
            key={'image' + index}
            style={[
              styles.columnRowTxt,
              style,
              column.styleItem || {},
              item[column.data + 'Style'] || {},
              {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: 8,
              },
            ]}>
            <View
              style={{
                width: 36,
                height: 36,
                borderRadius: 18,
                overflow: 'hidden',
                backgroundColor: Colors.grey9,
                justifyContent: 'center',
                alignItems: 'center',
                borderWidth: 2,
                borderColor: Colors.grey0,
              }}>
              <Image
                style={{
                  width: '100%',
                  height: '100%',
                  resizeMode: 'contain',
                  aspectRatio: 1,
                }}
                source={item?.image ? { uri: item.image } : img}
              />
            </View>
            <SociollaText
              style={
                item[column.data + 'Style'] || {
                  fontSize: 11,
                }
              }
              numberOfLines={column.numberOfLines || 0}>
              {column.data == 'name' && item.customer_type == 'b2b_vip' ? (
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <View style={{ maxWidth: '80%' }}>
                    <SociollaText
                      style={
                        item[column.data + 'Style'] || {
                          fontSize: 11,
                        }
                      }>
                      {data?.length > 28
                        ? `${data.substring(0, 28)}...`
                        : data || '-'}
                    </SociollaText>
                  </View>
                  <VipBadge />
                </View>
              ) : (
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <View style={{ maxWidth: '100%' }}>
                    <SociollaText
                      style={
                        item[column.data + 'Style'] || {
                          fontSize: 11,
                        }
                      }>
                      {data?.length > 28
                        ? `${data.substring(0, 28)}...`
                        : data || '-'}
                    </SociollaText>
                  </View>
                </View>
              )}
            </SociollaText>
          </View>
        )}
        {column.type == 'image' && (
          <View
            key={'image' + index}
            style={[
              styles.columnRowTxt,
              style,
              column.styleItem || {},
              item[column.data + 'Style'] || {},
            ]}>
            <Image
              style={{ width: 36, height: 36 }}
              width={36}
              height={36}
              source={{ uri: data }}
            />
          </View>
        )}
        {column.type == 'status_active' && (
          <View
            key={'image' + index}
            style={[
              styles.columnRowTxt,
              style,
              column.styleItem || {},
              item[column.data + 'Style'] || {},
              { alignItems: 'center' },
            ]}>
            <StatusBadge
              newStyle={true}
              status={data ? 'active' : 'in_active'}
            />
          </View>
        )}
        {column.type == 'action' && (
          <View
            key={'action' + index}
            style={[
              styles.columnRowTxt,
              style,
              item[column.data + 'Style'] || {},
              {
                padding: 0,
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
              },
            ]}>
            {column.action.map((action, index2) => {
              {
                return (
                  <TouchableOpacity
                    testID={`${testID}-row-${index}-action-${index2}`}
                    key={'action-detail-' + index2 + index}
                    onPress={() => triggerAction(action, item, index, column)}>
                    <Image
                      width={20}
                      height={20}
                      svg={true}
                      source={action.icon}
                      style={{
                        height: 20,
                        width: 20,
                        marginRight:
                          column.action.length == index2 + 1 ? 0 : 20,
                      }}
                    />
                  </TouchableOpacity>
                );
              }
            })}
          </View>
        )}
        {column.type == 'price' && (
          <View
            key={'text' + index}
            style={[styles.columnRowTxt, style, column.styleItem || {}]}>
            <SociollaText
              style={item[column.data + 'Style'] || {}}
              currency={true}>
              {data}
            </SociollaText>
          </View>
        )}
        {column.type == 'vat' && (
          <View
            key={'text' + index}
            style={[styles.columnRowTxt, style, column.styleItem || {}]}>
            <SociollaText style={item[column.data + 'Style'] || {}}>
              {data || 0}%
            </SociollaText>
          </View>
        )}
        {column.type == 'options' && (
          <View
            key={'text' + index}
            style={[styles.columnRowTxt, style, { padding: 0 }]}
          />
        )}
        {!column.type &&
          column?.label !== 'Customer Name' &&
          column?.label !== 'Description' && (
            <View
              key={'text' + index}
              style={[
                styles.columnRowTxt,
                style,
                column.styleItem || {},
                { height: '100%' },
                item[column.data + 'Style']
                  ? { alignItems: 'center', justifyContent: 'center' }
                  : {},
              ]}>
              {item[column.data + 'Style'] ? (
                <View
                  style={{
                    backgroundColor:
                      item[column.data + 'Style'].backgroundColor,
                    paddingHorizontal:
                      item[column.data + 'Style'].paddingHorizontal,
                    paddingVertical:
                      item[column.data + 'Style'].paddingVertical,
                    borderRadius: item[column.data + 'Style'].borderRadius,
                    minWidth: item[column.data + 'Style'].width || 105,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                  <SociollaText
                    style={{
                      fontSize: 11,
                      textAlign: 'center',
                      color: item[column.data + 'Style'].color,
                    }}
                    numberOfLines={column.numberOfLines || 0}>
                    {column?.data === 'market_code'
                      ? data
                        ? data.toUpperCase()
                        : '-'
                      : typeof data === 'boolean'
                      ? String(data)
                      : data ?? ''}
                    {column.data == 'name' &&
                    item.customer_type == 'b2b_vip' ? (
                      <View style={{ marginLeft: 5 }}>
                        <VipBadge />
                      </View>
                    ) : (
                      false
                    )}
                  </SociollaText>
                </View>
              ) : (
                <SociollaText
                  style={[
                    { flexShrink: 1, width: '100%', maxWidth: '100%' },
                    { fontSize: 11 },
                  ]}
                  numberOfLines={column.numberOfLines || 0}>
                  {column?.data === 'market_code'
                    ? data
                      ? data.toUpperCase()
                      : '-'
                    : typeof data === 'boolean'
                    ? String(data)
                    : data ?? ''}
                  {column.data == 'name' && item.customer_type == 'b2b_vip' ? (
                    <View style={{ marginLeft: 5 }}>
                      <VipBadge />
                    </View>
                  ) : (
                    false
                  )}
                </SociollaText>
              )}
            </View>
          )}
        {column.type == 'slot' && slot && slot[column.data] ? (
          <View
            key={'slot' + index}
            style={[styles.columnRowTxt, style, column.styleItem || {}]}>
            {slot[column.data]({
              data: item,
              index: index,
            })}
          </View>
        ) : (
          false
        )}
      </>
    );
  };

  const renderItemDekstop = ({ item, index }) => (
    <TouchableOpacity
      testID={`${testID}-row-${index}`}
      onPress={() =>
        callBackRowPress ? callBackRowPress({ item, index }) : false
      }
      style={[
        styles.tableRow,
        styleRow,
        { backgroundColor: index % 2 == 1 ? '#F7F7F7' : '#FFFFFF' },
        scrollItem ? { zIndex: 1 } : {},
      ]}>
      {newTable.map((column, index2) => {
        {
          return (
            <Item
              key={'table-list-' + index + '-' + index2}
              item={item}
              column={column}
              data={item[column.data]}
              index={index}
              style={{
                width: generateWidth(column),
                // marginTop: props?.isHaveMargin ? 15 : 0,
              }}
            />
          );
        }
      })}
    </TouchableOpacity>
  );

  let renderItem = ({ item, index }) => (
    <TouchableOpacity
      testID={`${testID}-row-${index}`}
      onPress={() =>
        callBackRowPress ? callBackRowPress({ item, index }) : false
      }
      style={[
        styles.tableRow,
        styleRow,
        { backgroundColor: index % 2 == 1 ? '#F7F7F7' : '#FFFFFF' },
      ]}>
      {newTable.map((column, index2) => {
        {
          return (
            <Item
              key={'table-list-' + index + '-' + index2}
              item={item}
              data={item[column.data]}
              index={index}
              style={{ width: column.width }}
            />
          );
        }
      })}
    </TouchableOpacity>
  );

  const SkeletonRow = ({ index }) => {
    const animatedValue = useRef(new Animated.Value(0)).current;

    useEffect(() => {
      const animation = Animated.loop(
        Animated.sequence([
          Animated.timing(animatedValue, {
            toValue: 1,
            duration: 1000,
            useNativeDriver: true,
          }),
          Animated.timing(animatedValue, {
            toValue: 0,
            duration: 1000,
            useNativeDriver: true,
          }),
        ]),
      );
      animation.start();
      return () => animation.stop();
    }, []);

    const opacity = animatedValue.interpolate({
      inputRange: [0, 1],
      outputRange: [0.3, 0.7],
    });

    return (
      <View
        style={[
          styles.tableRow,
          styleRow,
          { backgroundColor: index % 2 == 1 ? '#F7F7F7' : '#FFFFFF' },
        ]}>
        {newTable.map((column, index2) => (
          <View
            key={`skeleton-${index2}`}
            style={[
              styles.columntable,
              { width: generateWidth(column) },
              index2 + 1 < newTable.length
                ? {
                    borderRightColor: Colors.white,
                    borderRightWidth: 2,
                    height: 64,
                  }
                : {},
            ]}>
            {column?.label === 'Customer Name' ? (
              <View
                style={[
                  styles.columnRowTxt,
                  {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: 8,
                    width: '100%',
                  },
                ]}>
                <Animated.View
                  style={[
                    {
                      width: 36,
                      height: 36,
                      borderRadius: 18,
                      backgroundColor: Colors.grey0,
                      borderWidth: 2,
                      borderColor: Colors.grey0,
                    },
                    { opacity },
                  ]}
                />
                <Animated.View
                  style={[
                    {
                      width: 120,
                      height: 12,
                      borderRadius: 4,
                      backgroundColor: Colors.grey0,
                    },
                    { opacity },
                  ]}
                />
              </View>
            ) : (
              <Animated.View
                style={[
                  styles.columnRowTxt,
                  {
                    width: '70%',
                    height: 12,
                    borderRadius: 4,
                    backgroundColor: Colors.grey0,
                    marginTop: 0,
                  },
                  { opacity },
                ]}
              />
            )}
          </View>
        ))}
      </View>
    );
  };

  let renderHeader = null;

  if (headerComponent) {
    renderHeader = headerComponent;
  } else {
    if (isWeb && withHeader) {
      renderHeader = renderHeaderDekstop;
    }
  }

  if (itemComponent) {
    renderItem = itemComponent;
  } else {
    renderItem = renderItemDekstop;
  }
  const renderItemLegend = useCallback(
    (info) => {
      const element = renderItem(info);
      if (
        !element ||
        element === null ||
        element === undefined ||
        element === false
      ) {
        return null;
      }
      if (typeof element === 'string' || typeof element === 'number') {
        return <SociollaText>{String(element)}</SociollaText>;
      }
      return element;
    },
    [renderItem],
  );

  const defaultKeyExtractor = (item, index) => {
    return `table-list-${index}`;
  };

  const currentLimit = localParams
    ? localParams.limit || defaultLimit
    : paramsState.limit || defaultLimit;

  const onSetSkip = (data) => {
    if (localParams) {
      onSearchTable({ skip: data, limit: currentLimit }, 'pagination');
    } else {
      dispatch(paginationAdded({ skip: data, limit: currentLimit }));
    }
  };

  // callback when changing the rows per page (resets to first page)
  const onSetLimit = (newLimit) => {
    if (localParams) {
      onSearchTable({ skip: 0, limit: newLimit }, 'pagination');
    } else {
      dispatch(paginationAdded({ skip: 0, limit: newLimit }));
    }
  };

  // eslint-disable-next-line no-unused-vars
  const scrollToIndex = (scroll) => {
    flatlistRef.current.scrollToIndex(scroll);
  };

  const loadMore = () => {
    if (showLoadMoreLoading && !isWeb) {
      setOriginalLength(datas.length);
      let { skip } = { ...paramsState };
      if (localParams) {
        skip = localParams.skip;
        onSearchTable(
          { skip: skip + defaultLimit, limit: defaultLimit },
          'pagination',
        );
      } else {
        dispatch(
          paginationAdded({ skip: skip + defaultLimit, limit: defaultLimit }),
        );
      }
    }
  };

  const loadMoreCustomer = useCallback(() => {
    if (loading || loadingLoadMore || !showLoadMoreLoading) {
      return;
    }

    setOriginalLength(datas.length);

    let { skip } = { ...paramsState };
    if (localParams) {
      skip = localParams.skip;
      onSearchTable(
        { skip: skip + defaultLimit, limit: defaultLimit },
        'pagination',
      );
    } else {
      dispatch(
        paginationAdded({ skip: skip + defaultLimit, limit: defaultLimit }),
      );
    }
  }, [
    loading,
    loadingLoadMore,
    showLoadMoreLoading,
    datas,
    paramsState,
    totalData,
  ]);

  const onEndReachedHandler = useCallback(() => {
    loadMoreCustomer();
  }, [loadMoreCustomer]);

  const onSearch = useCallback(
    debounce((keyword) => {
      if (localParams) {
        onSearchTable({ keyword }, 'keyword');
      } else {
        searching(keyword);
      }
    }, 500),
    [],
  );

  const setSearchingArray = (filterDatas, keyword) => {
    const filterData = { ...filterDatas };
    let or = filterData['$or'] || [];
    if (searchKey && searchKey.length) {
      for (let index = 0; index < searchKey.length; index++) {
        if (keyword) {
          const check = or.findIndex((x) => x[searchKey[index]]);
          if (check > -1) {
            or.splice(check, 1, {
              [searchKey[index]]: {
                $regex: keyword,
                $options: 'i',
              },
            });
          } else {
            or.push({
              [searchKey[index]]: {
                $regex: keyword,
                $options: 'i',
              },
            });
          }
        } else {
          or = or.filter((dt) => !dt[searchKey[index]]);
        }
      }
    }
    if (or.length) {
      filterData['$or'] = or;
    } else {
      delete filterData['$or'];
    }
    return filterData;
  };

  const setSearching = (filterDatas, keyword) => {
    const filterData = { ...filterDatas };
    if (keyword) {
      filterData[searchKey] = keyword;
    } else {
      delete filterData[searchKey];
    }
    return filterData;
  };

  const searching = (keyword) => {
    if (localParams) {
      onSearchTable({ keyword }, 'keyword');
    } else {
      try {
        let filterData = JSON.parse(JSON.stringify(paramsState.filter));
        const isArr = Array.isArray(searchKey);
        if (isArr) {
          filterData = setSearchingArray(filterData, keyword);
        } else {
          filterData = setSearching(filterData, keyword);
        }
        if (keyword && keyword.length >= 3) {
          dispatch(paginationAdded({ skip: 0, limit: defaultLimit }));
          dispatch(filterAdded(filterData));
          setSavedFilter({ filters: filterData });
          if (props.onSearch) {
            props.onSearch(keyword);
          }
        } else {
          // Still save to filter but don't trigger search API
          dispatch(filterAdded(filterData));
          setSavedFilter({ filters: filterData });
        }
      } catch (error) {}
    }
  };

  useImperativeHandle(ref, () => ({
    scrollToIndex(scroll) {
      flatlistRef.current.scrollToIndex(scroll);
    },
  }));

  useEffect(() => {
    const tables = (table || []).filter((dt) => !dt.isHide);
    setNewTable(tables || []);
    setOriginalTable(tables || []);
    const filterList = (table || []).filter((dt) => dt.filter);
    setFilterTable(filterList);
    setSearchKeyword('');
  }, [table]);

  useEffect(() => {
    if (defaultLimit === props.datas.length) {
      setOriginalLength(0);
    }
  }, [props.datas]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      let keywordSearch = '';
      if (
        paramsState?.filter &&
        Object.keys(paramsState.filter).length > 0 &&
        searchKey
      ) {
        const or = paramsState.filter['$or'] || [];
        const isArr = Array.isArray(searchKey);
        if (isArr && searchKey.length > 0 && or.length === searchKey.length) {
          keywordSearch = or[0][searchKey[0]]['$regex'];
        }
        if (!isArr && searchKey && paramsState.filter[searchKey]) {
          keywordSearch = paramsState.filter[searchKey];
        }
      }
      checkKeyword(keywordSearch);
    }
    return () => {
      mounted = false;
    };
  }, [paramsState?.filter, searchKey]);

  const checkKeyword = useCallback(
    debounce((searchKeyword) => {
      setSearchKeyword(searchKeyword);
    }, 10),
    [],
  );

  useEffect(() => {
    if (isWeb && loading) {
      setShowSkeleton(true);
    } else if (isWeb && !loading) {
      const timer = setTimeout(() => {
        setShowSkeleton(false);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [loading, isWeb]);

  return (
    <View testID={testID} style={{ width: '100%' }}>
      {isWeb && topComponent && (
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 20,
            zIndex: 100,
            elevation: 100,
          }}>
          <View style={{ flexDirection: 'row' }}>
            {showSearch && (
              <View style={{ marginRight: 10 }}>
                <SearchTable
                  testID={`${testID}-search`}
                  value={searchKeyword}
                  onSearch={async (value) => {
                    await setSearchKeyword(value);
                    searching(value);
                  }}
                  withBorder={searchBorder}
                  searchPlaceholder={
                    searchPlaceholder
                      ? searchPlaceholder
                      : 'Search something...'
                  }
                  filterName={filterName}
                />
              </View>
            )}
            {showFilter && (
              <View style={{ marginRight: 10 }}>
                <Button
                  testID={`${testID}-filter-btn`}
                  buttonStyle={{
                    ...buttonPrimary,
                    ...buttonRounded,
                    width: 90,
                  }}
                  title={
                    <View style={{ flexDirection: 'row' }}>
                      {isFiltered ? (
                        <Image
                          style={{ width: 12, height: 15, marginRight: 10 }}
                          width={12}
                          height={15}
                          svg={true}
                          source={require('@assets/img/icons/check-circle-white.svg')}
                        />
                      ) : (
                        <Image
                          style={{ width: 12, height: 15, marginRight: 10 }}
                          width={12}
                          height={15}
                          svg={true}
                          source={require('@assets/img/icons/filter-white.svg')}
                        />
                      )}
                      <SociollaText
                        type="medium"
                        style={{ fontSize: 14, color: Colors.white }}>
                        Filter
                      </SociollaText>
                    </View>
                  }
                  onPress={() =>
                    dispatch(showPopup({ name: 'sociollaFilter', value: name }))
                  }
                />
              </View>
            )}
            {customAction && customAction}
          </View>
          {showPagination && (
            <Pagination
              testID={`${testID}-pagination-top`}
              totalData={count}
              limit={localParams ? localParams.limit : paramsState.limit}
              skip={localParams ? localParams.skip : paramsState.skip}
              onSetSkip={(val) => onSetSkip(val)}
              onSetLimit={(val) => onSetLimit(val)}
            />
          )}
        </View>
      )}
      {!isWeb && !hideSearch && (
        <SearchInputMobile
          testID={`${testID}-search`}
          placeholder={
            searchPlaceholder ? searchPlaceholder : 'Search something...'
          }
          onSearch={async (value) => {
            await setSearchKeyword(value);
            onSearch(value);
          }}
          searchKey={searchKey}
          value={searchKeyword}
        />
      )}
      <Wrapper styleContainer={styleContainer} scrollItem={scrollItem}>
        {isWeb && (
          <VirtualizedList
            data={
              isWeb && showSkeleton
                ? Array.from({ length: defaultLimit })
                : datas
            }
            getItemCount={
              isWeb && showSkeleton ? () => defaultLimit : getItemCount
            }
            getItem={
              isWeb && showSkeleton ? (data, index) => ({ index }) : getItem
            }
            onEndReachedThreshold={!isWeb ? 0.1 : threshold ? threshold : 0}
            onEndReached={totalData !== 0 ? onEndReachedHandler : loadMore}
            removeClippedSubviews={isAndroid ? false : true}
            style={[
              { width: '100%' },
              scrollItem ? {} : { overflow: isAndroid ? 'inherit' : 'unset' },
              maxHeight ? { maxHeight: maxHeight } : {},
              !isWeb ? { height } : {},
            ]}
            keyExtractor={keyExtractor ? keyExtractor : defaultKeyExtractor}
            ListHeaderComponent={renderHeader}
            renderItem={
              isWeb && showSkeleton
                ? ({ index }) => (
                    <SkeletonRow key={`skeleton-row-${index}`} index={index} />
                  )
                : renderItem
            }
            ref={flatlistRef}
            contentContainerStyle={datas.length > 0 ? {} : { flex: 1 }}
            ListEmptyComponent={
              <View
                style={{
                  flexGrow: 1,
                  alignItems: 'center',
                  justifyContent: isWeb ? 'center' : 'flex-start',
                  height: 200,
                  marginTop: isWeb ? 0 : 50,
                }}>
                {loading ? (
                  <ActivityIndicator size="large" color={Colors.blue0} />
                ) : (
                  <>
                    <SociollaText>
                      {emptyLabel ? emptyLabel : 'No data found.'}
                    </SociollaText>
                    {isFiltered && (
                      <View style={{ marginTop: 20 }}>
                        <Button
                          testID={`${testID}-reset-btn`}
                          type="default"
                          rounded
                          buttonStyle={{
                            ...(isWeb
                              ? { marginHorizontal: 10, width: 150 }
                              : {
                                  width: isMobileWeb
                                    ? Math.round(dimension.width / 2) - 20
                                    : '90%',
                                  alignSelf: 'center',
                                  marginRight: isMobileWeb ? 10 : 0,
                                }),
                          }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ fontSize: 14, color: Colors.black }}>
                              Reset
                            </SociollaText>
                          }
                          onPress={async () => {
                            await setSearchKeyword('');
                            if (localParams) {
                              onSearchTable(
                                { skip: 0, limit: defaultLimit },
                                'reset',
                              );
                            } else {
                              dispatch(paramsReseted());
                            }
                            if (props.onReset) {
                              props.onReset();
                            }
                          }}
                        />
                      </View>
                    )}
                  </>
                )}
              </View>
            }
            ListFooterComponent={
              showLoadMoreLoading &&
              !isWeb &&
              datas.length > 0 && (
                <ActivityIndicator
                  size="large"
                  color={Colors.blue0}
                  style={{ marginVertical: isNative ? 0 : 20, height: 100 }}
                />
              )
            }
            refreshControl={
              <RefreshControl
                refreshing={loading}
                onRefresh={() => dispatch(paramsReseted())}
              />
            }
            {...otherProps}
          />
        )}
        {!isWeb && (
          <LegendList
            testID={`${testID}-legend-list`}
            data={datas}
            onEndReachedThreshold={0.1}
            onEndReached={totalData !== 0 ? onEndReachedHandler : loadMore}
            style={[
              { width: '100%' },
              scrollItem ? {} : { overflow: 'visible' },
              maxHeight ? { maxHeight: maxHeight } : {},
              { height: safeLegendListHeight },
            ]}
            keyExtractor={keyExtractor ? keyExtractor : defaultKeyExtractor}
            ListHeaderComponent={headerComponent}
            renderItem={renderItemLegend}
            ref={flatlistRef}
            contentContainerStyle={datas.length > 0 ? {} : { flex: 1 }}
            ListEmptyComponent={
              <View
                style={{
                  flexGrow: 1,
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  height: 200,
                  marginTop: 50,
                }}>
                {loading ? (
                  <ActivityIndicator size="large" color={Colors.blue0} />
                ) : (
                  <>
                    <SociollaText>
                      {emptyLabel ? emptyLabel : 'No data found.'}
                    </SociollaText>
                    {isFiltered && (
                      <View style={{ marginTop: 20 }}>
                        <Button
                          type="default"
                          rounded
                          buttonStyle={{
                            width: '90%',
                            alignSelf: 'center',
                          }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ fontSize: 14, color: Colors.black }}>
                              Reset
                            </SociollaText>
                          }
                          onPress={async () => {
                            await setSearchKeyword('');
                            if (localParams) {
                              onSearchTable(
                                { skip: 0, limit: defaultLimit },
                                'reset',
                              );
                            } else {
                              dispatch(paramsReseted());
                            }
                            if (props.onReset) {
                              props.onReset();
                            }
                          }}
                        />
                      </View>
                    )}
                  </>
                )}
              </View>
            }
            ListFooterComponent={
              showLoadMoreLoading &&
              datas.length > 0 && (
                <ActivityIndicator
                  size="large"
                  color={Colors.blue0}
                  style={{ marginVertical: isNative ? 0 : 20, height: 100 }}
                />
              )
            }
            refreshControl={
              <RefreshControl
                refreshing={loading}
                onRefresh={() => dispatch(paramsReseted())}
              />
            }
            recycleItems={!isAndroid}
            maintainVisibleContentPosition={false}
            estimatedItemSize={72}
            scrollEnabled={otherProps.scrollEnabled}
            onScroll={otherProps.onScroll}
            onScrollBeginDrag={otherProps.onScrollBeginDrag}
            onScrollEndDrag={otherProps.onScrollEndDrag}
            onMomentumScrollBegin={otherProps.onMomentumScrollBegin}
            onMomentumScrollEnd={otherProps.onMomentumScrollEnd}
            scrollEventThrottle={otherProps.scrollEventThrottle}
            keyboardShouldPersistTaps={otherProps.keyboardShouldPersistTaps}
            showsVerticalScrollIndicator={
              otherProps.showsVerticalScrollIndicator
            }
            showsHorizontalScrollIndicator={
              otherProps.showsHorizontalScrollIndicator
            }
            bounces={otherProps.bounces}
            nestedScrollEnabled={otherProps.nestedScrollEnabled}
            horizontal={otherProps.horizontal}
          />
        )}
        {options && columnData?.options?.length && (
          <View
            testID={`${testID}-column-options`}
            style={{
              width: 275,
              position: 'absolute',
              right: 0,
              top: 50,
              backgroundColor: Colors.white,
              zIndex: 2,
              elevation: 5,
              flex: 1,
            }}>
            {columnData.options.map((item, idx) => (
              <TouchableOpacity
                testID={`${testID}-column-option-${idx}`}
                style={{
                  paddingVertical: 12,
                  paddingHorizontal: 15,
                  borderBottomColor: Colors.grey0,
                  borderBottomWidth: 1,
                }}
                key={`more-field-${idx}`}>
                <CheckBox
                  testID={`${testID}-column-checkbox-${idx}`}
                  value={item.checked}
                  checked={item.checked}
                  checkboxStyle={{ width: 16, height: 16 }}
                  onChange={() =>
                    addHeader(item, idx, columnIndex, columnData.index)
                  }>
                  <SociollaText style={{ lineHeight: 18 }}>
                    {item.label}
                  </SociollaText>
                </CheckBox>
              </TouchableOpacity>
            ))}
          </View>
        )}
      </Wrapper>
      {showPagination && !hideBottomPagination && (
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            marginTop: 16,
            zIndex: 1,
          }}>
          <Pagination
            testID={`${testID}-pagination-bottom`}
            totalData={count}
            limit={localParams ? localParams.limit : paramsState.limit}
            skip={localParams ? localParams.skip : paramsState.skip}
            dropUp={true}
            onSetSkip={(val) => onSetSkip(val)}
            onSetLimit={(val) => onSetLimit(val)}
          />
        </View>
      )}
      {showFilter && filterTable.length > 0 && (
        <ModalFull
          testID={`${testID}-filter-modal`}
          title="Filter"
          show={isShowFilter == name}
          noTranslate={true}
          onClose={() =>
            dispatch(showPopup({ name: 'sociollaFilter', value: false }))
          }>
          <SociollaFilter testID={`${testID}-filter`} data={filterTable} />
        </ModalFull>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.4,
    shadowRadius: 2,
    elevation: 3,
  },
  tableHeader: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap',
    backgroundColor: Colors.blue3,
    height: 48,
    width: '100%',
  },
  tableRow: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    alignItems: 'center',
    minHeight: 64,
    width: '100%',
  },
  columntable: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  columntableTxt: {
    color: 'white',
    fontWeight: 'bold',
    padding: 10,
    textAlign: 'center',
  },
  columnRowTxt: {
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingHorizontal: 20,
  },
  badgeContainer: {
    borderWidth: 1,
    borderColor: '#EA1A65',
    borderRadius: 15,
    paddingVertical: 4,
    paddingHorizontal: 12,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  badgeText: {
    color: '#D81B60',
    fontSize: 11,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

export default forwardRef(SociollaTable);
